



















































import { Component, Vue } from 'vue-property-decorator';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_failedInvoiceDeliveries, GQL_failedInvoiceDeliveries_failedInvoiceDeliveries } from '@/queries/__generated__/failedInvoiceDeliveries';
import gql from 'graphql-tag';

const FAILED_INVOICE_DELIVERIES = gql`
  query failedInvoiceDeliveries($limit: Int) {
    failedInvoiceDeliveries(limit: $limit) {
      id
      number
      customerParty {
        id
        name
      }
      latestMailLog {
        id
        deliveryMethod
        deliveryStatus
      }
    }
  }
`;

const DISMISS_FAILED_INVOICE_DELIVERY = gql`
  mutation dismissFailedInvoiceDelivery($logInvoiceMailId: ID!) {
    dismissFailedInvoiceDelivery(input: { logInvoiceMailId: $logInvoiceMailId }) {
      logInvoiceMail {
        id
        deliveryStatus
      }
    }
  }
`;

@Component
export default class FailedInvoiceDeliveriesWarning extends Vue {
  @SmartQuery<FailedInvoiceDeliveriesWarning, GQL_failedInvoiceDeliveries>({
    query: FAILED_INVOICE_DELIVERIES,
    fetchPolicy: 'cache-and-network',
    variables: () => ({ limit: 5 }),
    update: data => data.failedInvoiceDeliveries,
  }) private failedInvoiceDeliveries!: GQL_failedInvoiceDeliveries_failedInvoiceDeliveries[];

  private dismissingId: string | null = null;

  private dismiss(invoice: GQL_failedInvoiceDeliveries_failedInvoiceDeliveries) {
    if (!invoice.latestMailLog) return;

    this.dismissingId = invoice.latestMailLog.id;
    this.$apollo.mutate({
      mutation: DISMISS_FAILED_INVOICE_DELIVERY,
      variables: { logInvoiceMailId: invoice.latestMailLog.id },
    }).then(() => {
      // the dismissed delivery no longer matches the "failed" filter
      this.$apollo.queries.failedInvoiceDeliveries.refetch();
    }).finally(() => {
      this.dismissingId = null;
    });
  }
}
